import React from 'react';
import { Button, Col, Container, Nav, Navbar, Row } from 'react-bootstrap';

const Navigation = () => {
    return (
        <Container className="position-sticky z-index-sticky top-0">
            <Row>
                <Col>
                    <Navbar variant="" expand="lg" className="blur blur-rounded top-0 z-index-fixed shadow position-absolute my-3 py-2 start-0 end-0 mx-4">
                        <Container fluid>
                            <Navbar.Brand href="#home" className="font-weight-bolder ms-sm-3">
                                Jellema Automatisering
                            </Navbar.Brand>
                            <Button variant="primary" className="btn btn-sm bg-primary btn-round mb-0 ms-auto d-lg-none d-block">
                                Inloggen
                            </Button>
                            <Navbar.Toggle className="shadow-none ms-md-2" aria-controls="navbar-default">
                                    <span className="navbar-toggler-icon mt-2">
                                        <span className="navbar-toggler-bar bar1"></span>
                                        <span className="navbar-toggler-bar bar2"></span>
                                        <span className="navbar-toggler-bar bar3"></span>
                                    </span>
                            </Navbar.Toggle>
                            <Navbar.Collapse id="navbar-default" className="w-100 pt-3 pb-2 py-lg-0">

                                <Nav className="navbar-nav-hover mx-auto" as="ul">
                                    <Nav.Item as="li" className="mx-2">
                                        <Nav.Link href="#receive" className="ps-2 d-flex justify-content-between cursor-pointer align-items-center">
                                            Ontvangen
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li" className="mx-2">
                                        <Nav.Link href="#send" className="ps-2 d-flex justify-content-between cursor-pointer align-items-center">
                                            Verzenden
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                <Nav className="d-lg-block d-none" as="ul">
                                    <Nav.Item as="li">
                                        <Button variant="primary" className="btn btn-sm bg-primary btn-round mb-0 ms-auto d-none d-lg-inline-flex">
                                            Inloggen
                                        </Button>
                                    </Nav.Item>
                                </Nav>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </Col>
            </Row>
        </Container>
    );
}

export default Navigation;
